import { defineWebComponent } from "../webcomponents-utils";
import {WlRadioButtonGroup} from "./radioButtonGroup.component";

export * from './radioButtonGroup.component';
export default WlRadioButtonGroup;

defineWebComponent('wl-radio-button-group', WlRadioButtonGroup);
